<template>
  <div id="app">
    <headertop></headertop>
    <div class="main">
      <h1>直播课程</h1>
      <el-row style="margin-top: 5rem; margin: 2rem; margin-bottom:0;">
        <el-input placeholder="直播名称"  v-model="search" @keyup.enter.native="search_click()"  prefix-icon="el-icon-search"   style="width: 100%; float:right; " ></el-input>
      </el-row>
      <el-row style="cursor: pointer;" >
        <el-col v-for="(item, index) in liveList.data" :key="index" :offset="index > 0 ? 5 : 0">
          <el-card :body-style="{ padding: '0px' }"  >
            <div class="imgh" @click="dianji(item.num)">
              <img :src= item.img class="image">
            </div>
            <div style="padding: 14px;"  @click="dianji(item.num)">
              <h3 style="margin: 0;">{{item.name}}</h3>
              <p style="margin-top: 0;">{{item.type}} {{item.type_price}}</p>
              <div class="bottom clearfix"  @click="dianji(item.num)">
                <p style="margin: 0;" class="left">{{item.teacher}}</p>
                <p style="margin: 0;" class="right">{{item.time}}</p>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <div class="block center">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="liveList.current_page" :page-sizes="[6, 9, 24, 48]" :page-size="liveList.per_page"
          layout="total, sizes, prev, pager, next, jumper" :total="liveList.total">
        </el-pagination>
      </div>
    </div>
    <footerbom></footerbom>
  </div>
</template>

<script>
    import Header from '../../../components/index/public/visitor_NavHeader.vue';
  import Footer from '../../../components/index/public/NavFooter.vue';
  export default {
    name: 'App',
    data() {
      return {
        liveList:{
          data:[],
          current_page: 1, // 当前页码
          total: 0, // 总条数
          per_page: 9,
        },
        search:''
      }
    },
    components: {
      headertop: Header,
      footerbom: Footer
    },
    mounted: function (){
        this.get_task_info();
    },
    methods: {
      search_click(){
        this.get_task_info()
      },
      dianji(num){
        const h = this.$createElement;
        this.$notify({
          title: '温馨提示',
          message: h('b', { style: 'color: red'}, '更多功能，请联系王老师:13260265598(手机、微信同号)'),
          duration: 0
        })
        // this.$router.push({path:'/Liveintroduce',query:{num:num}})
      },
      get_task_info(){
        let _this = this;
          _this.axios
        .get("/v2/temp/live", {
          params: {page:_this.liveList.current_page,limit:_this.liveList.per_page,'keyword':_this.search},
        })
        .then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
            _this.liveList=res.data.data;
            for(let i=0;i< _this.liveList.data.length;i++){
              if(_this.liveList.data[i].type=='0'){
                _this.liveList.data[i].type="公共课"
             }else if(_this.liveList.data[i].type=='1'){
                _this.liveList.data[i].type="私密课"
             }else{
                _this.liveList.data[i].type="答疑"
             }
               if(_this.liveList.data[i].type_price=='0'){
                _this.liveList.data[i].type_price="免费"
             }else if(_this.liveList.data[i].type_price=='1'){
                _this.liveList.data[i].type_price="收费"
             }
            };
            } else {
              _this.$message.error("服务器内部错误");
            }
          } else {
            _this.$message.error("服务器内部错误");
          }
        });
      },
      handleSizeChange(val) {
        this.liveList.current_page = 1
        this.liveList.per_page = val
        this.get_task_info()
      },
      handleCurrentChange(val) {
        this.liveList.current_page = val
        this.get_task_info()
      },
    },



    }
</script>

<style scoped>
  .main {
    min-height: calc(100vh - 330px);
    width: 70%;
    padding: 20px;
    margin: 0 15%;
    z-index: 100;
    background-color: white;
  }

  h1 {
    margin: 20px;
  }
  h3{
    height: 50px;
    overflow:hidden;
  }
  /* 卡片 */
  .el-row {
    width: 90%;
    margin: 0 5%;
  }

  .image {
    width: 100%;
    display: block;
    height: 100%;
    position: absolute;
  }

  .imgh {
    width: 100%;
    padding-bottom: 56.25%;
    height: 0;
    position: relative;
  }

  .el-col {
    margin: 20px;
    width: calc(33% - 40px);
  }

  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }
</style>



// WEBPACK FOOTER //
// src/view/visitor/Live/Livebroadcast.vue